import React from 'react';
import PropTypes from 'prop-types';
import LossToActionOverview from '../LossToActionOverview';

const INTROverviewMaterialTable = ({
    data,
    columns,
    paginationData,
    sortingData,
    handlePageChange,
    isLoading = false
}) => {

    const scrollableColumnsArray = [
        // 'CBU',
        // 'DC',
        // 'Qty in Shipment',
        // 'Value in Shipment',
        // 'Number of Shipments',
        'Daywise Shipment Quantity',
        'MSTN Loss Impact Packs',
        'Mitigation by Intransit',
        'Overall Loss Mitigation',
        'Residual Loss Post Late GRN (Quantity)',
        'Stock Loss Details'
    ];

    return (
        <LossToActionOverview
            data={data}
            columns={columns}
            paginationData={paginationData}
            sortingData={sortingData}
            handlePageChange={handlePageChange}
            isLoading={isLoading}
            scrollableColumnsArray={scrollableColumnsArray}
            totalColumnName="Format"
            fixedColumnName="Format" 
            tableType="INTR Recovery Material View"
        />
    );
};

INTROverviewMaterialTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    columns: PropTypes.arrayOf(PropTypes.object).isRequired,
    paginationData: PropTypes.shape({
        page: PropTypes.number,
        rowsPerPage: PropTypes.number,
        totalRecords: PropTypes.number,
    }),
    sortingData: PropTypes.shape({
        sortBy: PropTypes.string,
        sortOrder: PropTypes.string,
    }),
    handlePageChange: PropTypes.func,
    isLoading: PropTypes.bool,
};

INTROverviewMaterialTable.defaultProps = {
    isLoading: false,
    paginationData: {},
    sortingData: {},
    handlePageChange: null,
};

export default React.memo(INTROverviewMaterialTable);